<template>
  <div class="w-full overflow-auto rounded">
    <table class="w-full">
      <thead class="dark:bg-ontick-steel-500 bg-gray-300 text-left">
        <tr>
          <th v-for="item in headers" :key="item.label">
            <div class="flex items-center">
              <span :class="{ 'sr-only': item.sr_only }">
                {{ item.label }}
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody
        class="dark:divide-ontick-steel-500 divide-ontick-steel-300 dark:bg-ontick-graphite-500 divide-y bg-gray-200 text-xs"
      >
        <tr v-for="trail in data" :key="trail.code">
          <!-- SWITCH -->
          <td>
            <div class="flex items-center justify-center gap-2">
              <div class="relative h-3 w-3">
                <div
                  class="absolute h-3 w-3 rounded-full"
                  :class="
                    ['ACTIVE', 'NEW'].includes(trail.orders[0].trail_order_status)
                      ? 'bg-ontick-green-600'
                      : 'bg-gray-400'
                  "
                ></div>
                <!-- <div
                  v-if="
                    ['ACTIVE', 'NEW'].includes(
                      trail.orders[0].trail_order_status
                    )
                  "
                  class="bg-ontick-green-600 absolute h-3 w-3 animate-ping rounded-full"
                ></div> -->
              </div>
              <ontick-switch-component
                :active="['ACTIVE', 'NEW'].includes(trail.orders[0].trail_order_status)"
                :disabled="['STOPPED'].includes(trail.orders[0].trail_order_status)"
                @switch="startDialog(trail)"
              />
            </div>
          </td>

          <!-- NOME -->
          <td>
            <div class="flex flex-col gap-1">
              <span>
                {{ trail.info.strategy_name }}
              </span>
              <span class="text-gray-500"> ID: {{ trail.orders[0].trail_order_id }} </span>
            </div>
          </td>

          <!-- ENTRADA -->
          <td>
            <status-exec-trail-component
              :orders="trail.orders.filter((item) => item.trail_order_goal === 'ENTRY')"
              :entry="trail.info.alg_ord_entry"
              :calc_type="trail.info.alg_ord_calc_type"
              trailOrderGoal="ENTRY"
            />
          </td>

          <!-- SAÍDA -->
          <td>
            <status-exec-trail-component
              :orders="trail.orders.filter((item) => item.trail_order_goal === 'EXIT')"
              :calc_type="trail.info.alg_ord_calc_type"
              trailOrderGoal="EXIT"
            />
          </td>

          <td>
            <div class="flex flex-col gap-1">
              <div class="flex items-center gap-1">
                <i v-html="$icons.play_green" v-if="calculaPNL(trail) > 0"></i>
                <i v-html="$icons.play_red" v-else-if="calculaPNL(trail) < 0"></i>
                <i class="h-3 w-3 rounded-full bg-gray-400" v-else></i>
                <span>
                  {{ calculaPNL(trail) | currency }}
                </span>
              </div>
              <span class="text-xs text-gray-500"
                >({{ calculaPorcentagem(trail.orders[0].trail_order_fin_volume, calculaPNL(trail)) }}%)</span
              >
            </div>
          </td>
          <td>
            <div class="flex w-full items-center justify-center">
              <button
                @click="openDetailsModal(trail)"
                class="text-ontick-blue-600 p-2 transition-all hover:brightness-125"
              >
                <i v-html="$icons.details"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <ontick-modal-component size="small" :open="startModalIsActive" @close="startModalIsActive = false">
      <start-modal-component :order="order" @close="startModalIsActive = false" />
    </ontick-modal-component>
    <ontick-modal-component size="small" :open="stopModalIsActive" @close="stopModalIsActive = false">
      <stop-modal-component :order="order" @close="stopModalIsActive = false" />
    </ontick-modal-component>
    <ontick-modal-component :open="detailsModalIsActive" @close="detailsModalIsActive = false">
      <details-modal-component
        :modalIsLoading="detailsModalIsLoading"
        :modalData="detailsData"
        :detailsSymbols="detailsSymbols"
      />
    </ontick-modal-component>
  </div>
</template>

<script>
import ontickSwitchComponent from "../../../../../shared/components/basic/ontick-switch.component.vue";
import statusExecTrailComponent from "./status-exec-trail.component.vue";
import ontickModalComponent from "../../../../../shared/components/basic/ontick-modal.component.vue";
import stopModalComponent from "../../stop-modal.component.vue";
import startModalComponent from "../../start-modal.component.vue";
import detailsModalComponent from "../details-modal.component.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    statusExecTrailComponent,
    ontickSwitchComponent,
    ontickModalComponent,
    stopModalComponent,
    startModalComponent,
    detailsModalComponent,
  },

  props: {
    data: {
      type: Array,
    },
  },

  data() {
    return {
      headers: [
        {
          label: "Ligar/desligar investimento",
          sr_only: true,
        },
        {
          label: "Estratégia",
        },
        {
          label: "Entrada",
        },
        {
          label: "Saída",
        },
        {
          label: "Resultado",
        },
        {
          label: "Detalhes",
        },
      ],
      stopModalIsActive: false,
      startModalIsActive: false,
      detailsModalIsActive: false,
      detailsModalIsLoading: false,
      detailsData: {},
      order: {},
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
    detailsSymbols() {
      return this.data.find((trail) => trail.orders[0].alg_ord_id === this.detailsData.alg_ord_id);
      // return this.orders.find(
      //   (item) => item.alg_ord_id === this.modalData.alg_ord_id
      // );
    },
  },

  methods: {
    calculaPorcentagem(fin_volume, pnl) {
      return ((pnl / fin_volume) * 100).toFixed(1);
    },
    calculaPNL(trail) {
      let { orders } = trail;
      let entry = {
        symbol_1: {
          direction: orders[0].trail_order_type,
          curr_price: trail.info.symbol_1_last,
          price_avg: orders[0].trail_order_price_avg,
          filled_volume: orders[0].trail_order_volume_filled || 0,
          volume_leaves: orders[0].trail_order_volume_leaves || 0,
        },
        symbol_2: {
          direction: orders[1].trail_order_type,
          curr_price: trail.info.symbol_2_last,
          price_avg: orders[1].trail_order_price_avg,
          filled_volume: orders[1].trail_order_volume_filled || 0,
          volume_leaves: orders[1].trail_order_volume_leaves || 0,
        },
      };
      let exit = {
        symbol_1: {
          direction: orders[2].trail_order_type,
          curr_price: trail.info.symbol_1_last,
          price_avg: orders[2].trail_order_price_avg,
          filled_volume:
            !orders[2].trail_order_volume_filled && !orders[2].trail_order_volume_leaves
              ? 0
              : orders[2].trail_order_volume_filled,
          volume_leaves:
            !orders[2].trail_order_volume_filled && !orders[2].trail_order_volume_leaves
              ? entry.symbol_1.filled_volume
              : orders[2].trail_order_volume_leaves,
        },
        symbol_2: {
          direction: orders[3].trail_order_type,
          curr_price: trail.info.symbol_2_last,
          price_avg: orders[3].trail_order_price_avg,
          filled_volume:
            !orders[3].trail_order_volume_filled && !orders[3].trail_order_volume_leaves
              ? 0
              : orders[3].trail_order_volume_filled,
          volume_leaves:
            !orders[3].trail_order_volume_filled && !orders[3].trail_order_volume_leaves
              ? entry.symbol_2.filled_volume
              : orders[3].trail_order_volume_leaves,
        },
      };

      let pnlComprada, pnlVendida, pnlFinal;

      if (entry.symbol_1.direction === "BUY") {
        pnlComprada =
          exit.symbol_1.filled_volume * exit.symbol_1.price_avg +
          exit.symbol_1.volume_leaves * exit.symbol_1.curr_price -
          entry.symbol_1.filled_volume * entry.symbol_1.price_avg;

        // console.log(entry, exit);
        pnlVendida =
          entry.symbol_2.filled_volume * entry.symbol_2.price_avg -
          (exit.symbol_2.filled_volume * exit.symbol_2.price_avg +
            exit.symbol_2.volume_leaves * exit.symbol_2.curr_price);
        pnlFinal = pnlComprada + pnlVendida;
        return pnlFinal;
      } else if (entry.symbol_1_direction === "SELL") {
        pnlComprada =
          exit.symbol_2.filled_volume * exit.symbol_2.price_avg +
          exit.symbol_2.volume_leaves * exit.symbol_2.curr_price -
          entry.symbol_2.filled_volume * entry.symbol_2.price_avg;
        pnlVendida =
          entry.symbol_1.filled_volume * entry.symbol_1.price_avg -
          (exit.symbol_1.filled_volume * exit.symbol_1.price_avg +
            exit.symbol_1.volume_leaves * exit.symbol_1.curr_price);
        pnlFinal = pnlComprada + pnlVendida;
        return pnlFinal;
      }

      return 0;
    },
    startDialog(order) {
      this.order = order;
      this.stopModalIsActive = true;
    },
    // openDetailsModal(trail) {
    //   this.$emit("open-details", trail.orders[0].trail_order_id);
    // },
    openDetailsModal(trail) {
      const id = trail.orders[0].trail_order_id;
      const account_id = this.getSelectedAccount.account_id;
      this.detailsModalIsLoading = true;
      this.detailsModalIsActive = true;
      this.$api
        .get(this.$endpoint.GET_ALGO_ORDER_DETAILS, {
          params: {
            alg_ord_id: id,
            account_id: account_id,
          },
        })
        .then((res) => {
          // console.log(res.data);
          this.detailsData = { ...res.data, ald_ord_id: id };
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
          this.detailsModalIsActive = false;
        })
        .finally(() => {
          this.detailsModalIsLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
th {
  @apply px-3 py-2  text-sm font-bold;
}
td {
  @apply p-3 text-left;
}
</style>
